import React from 'react'
import './index.css';
import { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { IoMail } from "react-icons/io5";
import { IoLogoLinkedin } from "react-icons/io5";
import { IoLogoInstagram } from "react-icons/io5";
import { FaGithubSquare } from "react-icons/fa";

export const Contact = () => {

  const controls = useAnimation();
  useEffect(() => {
    controls.start({ opacity: 1, x: 0 });
  }, [controls]);
  return (
    <motion.div className='Contact'
      initial={{ opacity: 0, x: -20 }}
      animate={controls}
      transition={{ duration: 1 }}
    >
      <div className="Header">
        Contact
      </div>
      <div className="Details">
        <div className="CardsArea">
          <div className="Cards" id='mail'>
            <div className="Icon">
              <IoMail />
            </div>
            <a href="mailto:abirbhattacharya82@gmail.com">
              abirbhattacharya82@gmail.com
            </a>
            <div className="details">
              Ready to take the next step? Drop me an email at abirbhattacharya82@gmail.com and let's discuss how we can turn your ideas into a captivating online presence. Whether you're starting from scratch or need enhancements to an existing site, I've got you covered.
            </div>
          </div>
          <div className="Cards" id='github'>
            <div className="Icon">
              <FaGithubSquare />
            </div>
            <a href="https://github.com/abirbhattacharya82">
              abirbhattacharya82
            </a>
            <div className="details">
              For a glimpse into my coding prowess and commitment to transparency, check out my open source projects on GitHub: abirbhattacharya82. Collaborate, learn, and explore the world of web development together!
            </div>
          </div>
          <div className="Cards" id='insta'>
            <div className="Icon">
              <IoLogoInstagram />
            </div>
            <a href="https://www.instagram.com/iamabir82/">
              @iamabir82
            </a>
            <div className="details">
              Join me on my digital adventures around the globe! Follow me on Instagram @iamabir82 to witness the places I explore, the cultures I experience, and the moments I capture. Let's connect beyond the code!
            </div>
          </div>
          <div className="Cards" id='linkedin'>
            <div className="Icon">
              <IoLogoLinkedin />
            </div>
            <a href="https://www.linkedin.com/in/abir-bhattacharya-6982551a9/">
              abir-bhattacharya-6982551a9
            </a>
            <div className="details">
              Looking to expand your professional network? Connect with me on LinkedIn at Abir Bhattacharya to stay updated on industry trends, insights, and potential collaboration opportunities. Let's build meaningful connections in the world of web development!
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}
